import { DatePicker, Space, Select, Table, message, Spin, Form, Image, Tooltip, Button, Divider } from 'antd';
import dayjs from 'dayjs';
import { FileExcelOutlined } from '@ant-design/icons';
import constants from '../../constants/constants';
import { useContext, useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import WebLinks from '../../api/WebLinks';
import Cookies from 'js-cookie';
import APIUtils from '../../api/APIUtils';
import { downloadFiles, trackPageAccess } from '../../globalFunctions/GlobalFunctions';
import moment from 'moment';
import { CommonContext } from '../../Context';
const { RangePicker } = DatePicker;

const BoostOrders = (props) => {

	const isSelfService= sessionStorage.getItem('isSelfService');
	const isBoost= sessionStorage.getItem('isBoost');
	const commonContext=useContext(CommonContext);
	const buyerId = commonContext.common.buyerId;
	//Variable declaration
	const columns = [
		{
			title: 'Created On',
			dataIndex: 'createdOn',
			key: 'createdOn',
			width:'17%',
			render: (createdOn)=>{
				return moment(createdOn).format('YYYY-MM-D, h:mm a');
			}
		},
		{
			title: 'Order ID',
			dataIndex: 'id',
			key: 'id',
			sorter: (a, b) => a.id - b.id,
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			sorter: (a, b) => a.description - b.description,
		},
		{
			title: 'No. of Products',
			dataIndex: 'numberOfProducts',
			key: 'numberOfProducts',
			align: 'center',
			sorter: (a, b) => a.numberOfProducts - b.numberOfProducts,
		},
		// {
		// 	title: 'Supplier Price',
		// 	dataIndex: 'supplierPrice',
		// 	key: 'supplierPrice',
		// 	align: 'center',
		// 	sorter: (a, b) => a.supplierPrice - b.supplierPrice,
		// 	render: (text,record)=>{
		// 		return <span>{record.priceCurrencySymbol+" "+text}</span>
		// 	}
		// },
		{
			title: 'Price',
			dataIndex: 'buyerPrice',
			key: 'buyerPrice',
			align: 'center',
			sorter: (a, b) => a.buyerPrice - b.buyerPrice,
			render: (text,record)=>{
				return <span>{record.priceCurrencySymbol+" "+text}</span>
			}
		},
		// {
		// 	title: 'Completed',
		// 	dataIndex: 'screeningQuestionsIncomplete',
		// 	key: 'screeningQuestionsIncomplete',
		// 	align: 'center',
		// 	sorter: (a, b) => a.screeningQuestionsIncomplete - b.screeningQuestionsIncomplete,
		// },
		// {
		// 	title: 'Price Net',
		// 	dataIndex: 'priceNet',
		// 	key: 'priceNet',
		// 	align: 'center',
		// 	sorter: (a, b) => a.priceNet - b.priceNet,
		// 	render: (text,record)=>{
		// 		return <span>{record.priceCurrencySymbol+" "+text}</span>
		// 	}
		// },
		// {
		// 	title: 'Completed On',
		// 	dataIndex: 'completedOn',
		// 	key: 'completedOn',
		// 	render: (completedOn)=>{
		// 		return completedOn?moment(completedOn).format('YYYY-MM-D, h:mm a'):"In progress";
		// 	}
		// },
		// {
		// 	title: 'Invoiced',
		// 	dataIndex: 'screeningQuestionsIncomplete',
		// 	key: 'screeningQuestionsIncomplete',
		// 	align: 'center',
		// 	sorter: (a, b) => a.screeningQuestionsIncomplete - b.screeningQuestionsIncomplete,
		// },
		// {
		// 	title: 'Invoiced On',
		// 	dataIndex: 'invoicedOn',
		// 	key: 'invoicedOn',
		// 	hidden: isSelfService==="true"|| isBoost==="true",
		// 	render: (invoicedOn)=>{
		// 		return invoicedOn?moment(invoicedOn).format('YYYY-MM-D, h:mm a'):"In progress";
		// 	}
		// },
		// {
		// 	title: 'Do not Invoice',
		// 	dataIndex: 'screeningQuestionsIncomplete',
		// 	key: 'screeningQuestionsIncomplete',
		// 	align: 'center',
		// 	sorter: (a, b) => a.screeningQuestionsIncomplete - b.screeningQuestionsIncomplete,
		// },
		// {
		// 	title: 'Buyer Price Currency',
		// 	dataIndex: 'screeningQuestionsIncomplete',
		// 	key: 'screeningQuestionsIncomplete',
		// 	align: 'center',
		// 	sorter: (a, b) => a.screeningQuestionsIncomplete - b.screeningQuestionsIncomplete,
		// },
		// {
		// 	title: 'Price Currency',
		// 	dataIndex: 'screeningQuestionsIncomplete',
		// 	key: 'screeningQuestionsIncomplete',
		// 	align: 'center',
		// 	sorter: (a, b) => a.screeningQuestionsIncomplete - b.screeningQuestionsIncomplete,
		// },
	];
	const expandedTableColumns=[
		// {
		// 	key: 'emptyCol',
		// 	width:'31%',
		// },
		{
			title: 'Job Title',
			dataIndex: 'title',
			key: 'title',
			sorter: (a, b) => a.title - b.title,
		},{
			title: 'City',
			dataIndex: 'city',
			key: 'city',
			sorter: (a, b) => a.city - b.city,
		},
		{
			title: 'Product Name',
			dataIndex: 'productName',
			key: 'productName',
			sorter: (a, b) => a.productName - b.productName,
		},
		{
			title: 'No. of Products',
			dataIndex: 'numberOfProducts',
			key: 'numberOfProducts',
			align: 'center',
			sorter: (a, b) => a.numberOfProducts - b.numberOfProducts,
			render: (text,record)=>{
				return <span>{"1"}</span>
			}
		},
		// {
		// 	title: 'Supplier Price',
		// 	dataIndex: 'supplierPrice',
		// 	key: 'supplierPrice',
		// 	align: 'center',
		// 	sorter: (a, b) => a.supplierPrice - b.supplierPrice,
		// 	render: (text,record)=>{
		// 		return <span>{record.buyerPriceCurrency+" "+text}</span>
		// 	}
		// },
		{
			title: 'Price',
			dataIndex: 'buyerPrice',
			key: 'buyerPrice',
			align: 'center',
			sorter: (a, b) => a.buyerPrice - b.buyerPrice,
			render: (text,record)=>{
				return <span>{record.priceCurrencySymbol+" "+text}</span>
			}
		},
		// {
		// 	title: 'Price Net',
		// 	dataIndex: 'priceNet',
		// 	key: 'priceNet',
		// 	align: 'center',
		// 	sorter: (a, b) => a.priceNet - b.priceNet,
		// 	render: (text,record)=>{
		// 		return <span>{record.priceCurrencySymbol+" "+text}</span>
		// 	}
		// },
		// {
		// 	title: 'Completed On',
		// 	dataIndex: 'completedOn',
		// 	key: 'completedOn',
		// 	render: (completedOn)=>{
		// 		return completedOn?moment(completedOn).format('YYYY-MM-D, h:mm a'):"In progress";
		// 	}
		// },
		// {
		// 	title: 'Post Status',
		// 	dataIndex: 'postStatus',
		// 	key: 'postStatus',
		// },
		{
			key: 'emptyCol2',
			width:'12%',
		},
		// {
		// 	title: 'Invoiced On',
		// 	dataIndex: 'invoicedOn',
		// 	key: 'invoicedOn',
		// 	render: (invoicedOn)=>{
		// 		return invoicedOn?moment(invoicedOn).format('YYYY-MM-D, h:mm a'):"In progress";
		// 	}
		// },
	];
	const [boostData, setBoostOrderData] = useState([]);
	const [currentPage, setCurrentPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [rangePickerValue, setRangePickerValue] = useState([]);
	const [loader, setLoader] = useState(false);
	const [totalBoostCount, setTotalBoostCount] = useState(0);
	const [qualityReportTotal, setQualityReportTotal] = useState([]);
	const [expandedRowKeys, setExpandedRowKeys] = useState([]);
	const [form] = Form.useForm();

	useEffect(() => {
		const date1 = dayjs().startOf('month')
		const date2 = dayjs().endOf('month')
		form.setFieldsValue({
			rangePicker: [
				date1,
				date2,
			],
		});
		setRangePickerValue([
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat),
		]);
		GetBoostOrderData(1, 100,
			date1.format(constants.MonthFormat),
			date2.format(constants.MonthFormat));
			trackPageAccess(buyerId,window.location.href)
	}, []);


	//Functions
	//Function runs when range picker value is changed
	const RangePickerChanged = debounce((_, dateStrings) => {
		//props.changeDate(dateStrings);
		setRangePickerValue([
			dayjs(dateStrings[0], constants.MonthFormat),
			dayjs(dateStrings[1], constants.MonthFormat),
		]);
		GetBoostOrderData(currentPage, pageSize, dateStrings[0], dateStrings[1]);
	}, 500);

	//Function to Month report data
	const GetBoostOrderData = async (currentPage, pazeSize, startDate, endDate) => {
		setLoader(true);
		const response = await APIUtils.apiCall('GET', WebLinks.GetBoostData + buyerId 
		 + "&fromDate=" + startDate + "&toDate=" + endDate + "&limit=" + pazeSize + "&pageNo=" + currentPage
		);
		if (!response.isCatch && response.resultObj.statusCode === "2000") {
			//setQualityReportTotal(response.resultObj.data.pop());
			setBoostOrderData(response.resultObj.data);
			setTotalBoostCount(response.resultObj.getCount);
			setExpandedRowKeys(
				response.resultObj.data
					.filter((item) => item?.boostOrderProducts?.length)
					.map((item) => String(item.id))
			);
			setLoader(false);
		} else {
			setBoostOrderData([]);
      setTotalBoostCount(0);
			setLoader(false);
			message.error(response.resultObj.message);
		}
	}

	//Function on change of application table
	const onchangeApplicationTable = (pagination, filters, sorter) => {
		if (pagination) {
			if (pageSize !== pagination.pageSize) {
				setCurrentPage(1);
			} else {
				setCurrentPage(pagination?.current);
			}
			setPageSize(pagination?.pageSize);
			GetBoostOrderData(pagination?.current, pagination?.pageSize, rangePickerValue[0], rangePickerValue[1])
		}
	};

	//Function to download as excel
	// const downloadFile = () => {
	// 	setLoader(true)
	// 	downloadFiles(WebLinks.DownloadApplicationQualityReport+buyerId + `&fromDate=${dayjs(rangePickerValue[0]).format(constants.MonthFormat)}&toDate=${dayjs(rangePickerValue[1]).format(constants.MonthFormat)}`,"ApplicationQualityReport.xlsx");
	// 	setTimeout(() => {
	// 			setLoader(false)
	// 	}, 3000);
	// };

	//Function to display the month total in the table
	// const monthReportSummary = () => {
	// 	return (
	// 		<>
	// 			<Table.Summary.Row className='bg-teal-50'>
	// 				<Table.Summary.Cell index={0} align='center'>
	// 					<strong>Totals</strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={1} className='text-center'>
	// 					<strong>{qualityReportTotal?.totalApps}</strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={2} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.internationals}<span>({qualityReportTotal?.internationalPer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={3} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.minimumDataMissing}<span>({qualityReportTotal?.minimumDataMissingPer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={4} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.screeningQuestionsIncomplete}<span>({qualityReportTotal?.screeningQuestionsIncompletePer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={5} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.failedKillerQuestions}<span>({qualityReportTotal?.failedKillerQuestionPer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={6} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.qualityFilterFailed}<span>({qualityReportTotal?.qualityFilterFailedPer}%)</span></Space></strong>					
  //         </Table.Summary.Cell>
	// 				<Table.Summary.Cell index={7} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.tooManyApplies}<span>({qualityReportTotal?.tooManyAppliePer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 				<Table.Summary.Cell index={8} className='text-center'>
  //           <strong><Space size={3}>{qualityReportTotal?.alreadyExists}<span>({qualityReportTotal?.alreadyExistPer}%)</span></Space></strong>
	// 				</Table.Summary.Cell>
	// 			</Table.Summary.Row>
	// 		</>
	// 	)
	// };

			//Funcion to render inner table
	const getBoostInnerTable = (tableData) => {
		return (
			<Table
				bordered
				size="small"
				columns={expandedTableColumns}
				dataSource={tableData}
				pagination={false}
			/>
		)
	}

	return (
		<>
			<Spin spinning={loader}>
      <div className='uppercase font-bold text-xl'>Boost Orders</div>
			<Divider className='my-3'/>
				<div>
					 <div className='flex flex-wrap gap-3 justify-between items-center mb-3'>
						<Form form={form}>
							<Form.Item name="rangePicker" className='mb-0'>
								<RangePicker picker="month"
									placeholder={["From", "To"]}
									onChange={RangePickerChanged}
									format={constants.MonthFormat} />
							</Form.Item>
						</Form>
					</div> 
					<div className='overflow-x-auto'>
						<Table
							columns={columns}
							dataSource={boostData}
							scroll={{
								x: 1000,
							}}
							onChange ={onchangeApplicationTable}
							sortDirections={['descend', 'ascend', 'descend']}
							pagination={{
								total: totalBoostCount,
								// showSizeChanger: true,
								// pageSizeOptions: ["25", "50", "100"],
								defaultPageSize: 100,
								// current: currentPage,
							}}
							// pagination={false}
							//summary={() => monthReportSummary()}
							rowKey={(record) => String(record.id)}
							expandable={{
								expandedRowKeys,
								onExpandedRowsChange: (keys) => {
									setExpandedRowKeys(keys);
								},
								expandedRowRender: (record) => (<div>
										{getBoostInnerTable(record.boostOrderProducts)}
									</div>),
							}}
						/>
					</div>
				</div>
			</Spin>
		</>
	);
};

export default BoostOrders;